// @flow

const huLocale = {
  'AttributionControl.ToggleAttribution': 'Atribúció ki/bekapcsolása.',
  'AttributionControl.MapFeedback': 'térkép visszajelzés',
  'FullscreenControl.Enter': 'teljes képernyő bekapcsolás',
  'FullscreenControl.Exit': 'teljes képernyő kilkapcsolás',
  'GeolocateControl.FindMyLocation': 'Hol vagyok?',
  'GeolocateControl.LocationNotAvailable': 'Helymeghatározás nem lehetséges.',
  'LogoControl.Title': 'Mapbox logo',
  'Map.Title': 'térkép',
  'NavigationControl.ResetBearing': 'északi irányba állítás',
  'NavigationControl.ZoomIn': 'nagyítás',
  'NavigationControl.ZoomOut': 'kicsinyítés',
  'ScrollZoomBlocker.CtrlMessage': 'Használj ctrl + scroll-t a térkép nagyításhoz / kicsinyítéshez.',
  'ScrollZoomBlocker.CmdMessage': 'Használj ⌘ + scroll-t nagyításhoz / kicsinyítéshez.',
  'TouchPanBlocker.Message': 'Használj két ujjat a térkép mozgatásához.'
};

export default huLocale;